import { render, staticRenderFns } from "./arvioitavat-kokonaisuudet-lista-vastuuhenkilo.vue?vue&type=template&id=118cc776&"
import script from "./arvioitavat-kokonaisuudet-lista-vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./arvioitavat-kokonaisuudet-lista-vastuuhenkilo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports